// Additional i18n bundles for:
// - Department contact cards on the home page
// - Dedicated Technology page contact block (Nart Charoukh)
// - Human Resources page + application form
// - Nav labels for HR
//
// Side-effect: merges `nav.hr` into the shared translations.nav.

import { translations as base } from "./translations";

const NAV_HR = {
  tr: "İnsan Kaynakları",
  en: "Careers",
  ar: "الموارد البشرية",
  es: "Carreras",
  ru: "Карьера",
  de: "Karriere",
  fr: "Carrières",
};

Object.keys(NAV_HR).forEach((loc) => {
  if (base[loc] && base[loc].nav) {
    base[loc].nav.hr = NAV_HR[loc];
  }
});

// ─────────────────────────────────────────────────────────────
// Department contact cards (Home → Contact section)
// ─────────────────────────────────────────────────────────────

export const DEPARTMENTS = {
  tr: {
    eyebrow: "DOĞRUDAN İLETİŞİM",
    title: "Konunuza göre doğru ekiple bağlantı kurun.",
    lead: "Aşağıdaki departmanlardan doğrudan bize ulaşabilir ya da formu doldurabilirsiniz.",
    general: {
      tag: "GENEL",
      title: "Kurumsal İletişim",
      person: "TBS Yönetim",
      desc: "Genel talepler, danışmanlık, ticari işbirliği ve yatırımcı ilişkileri için.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "IT & SİBER GÜVENLİK",
      title: "IT & Siber Güvenlik",
      person: "Nart Charoukh",
      desc: "Sızma testi, DDoS, SOC/SIEM, güvenli yazılım geliştirme ve tüm teknoloji talepleri.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "AVRUPA BİRLİĞİ ÜLKELERİ",
      title: "Avrupa Birliği Ülkeleri",
      person: "Dr. Mithat Bayındır",
      desc: "AB pazarına giriş, lisanslama, mevzuat uyumu ve Avrupa merkezli kurumsal ilişkiler.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Ara",
    actionEmail: "E-posta Gönder",
  },
  en: {
    eyebrow: "DIRECT CONTACT",
    title: "Connect with the right team for your inquiry.",
    lead: "Reach out to the relevant department directly or use the form below.",
    general: {
      tag: "GENERAL",
      title: "Corporate Contact",
      person: "TBS Management",
      desc: "General inquiries, consulting, commercial partnerships and investor relations.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "IT & CYBER SECURITY",
      title: "IT & Cyber Security",
      person: "Nart Charoukh",
      desc: "Pentesting, DDoS, SOC/SIEM, secure software development and all technology requests.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "EUROPEAN UNION",
      title: "European Union Countries",
      person: "Dr. Mithat Bayındır",
      desc: "EU market entry, licensing, regulatory compliance and European corporate relations.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Call",
    actionEmail: "Send Email",
  },
  ar: {
    eyebrow: "تواصل مباشر",
    title: "تواصل مع الفريق المناسب لطلبك.",
    lead: "تواصل مع القسم المختص مباشرة أو استخدم النموذج أدناه.",
    general: {
      tag: "عام",
      title: "التواصل المؤسسي",
      person: "إدارة TBS",
      desc: "الاستفسارات العامة والاستشارات والشراكات التجارية وعلاقات المستثمرين.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "تقنية المعلومات والأمن السيبراني",
      title: "تقنية المعلومات والأمن السيبراني",
      person: "نارت شاروخ",
      desc: "اختبارات الاختراق و DDoS و SOC/SIEM وتطوير البرمجيات الآمنة وجميع طلبات التقنية.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "دول الاتحاد الأوروبي",
      title: "دول الاتحاد الأوروبي",
      person: "د. مثيات بايندير",
      desc: "دخول سوق الاتحاد الأوروبي والترخيص والامتثال التنظيمي والعلاقات المؤسسية الأوروبية.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "اتصل",
    actionEmail: "أرسل بريد",
  },
  es: {
    eyebrow: "CONTACTO DIRECTO",
    title: "Conéctese con el equipo adecuado para su consulta.",
    lead: "Contacte directamente con el departamento correspondiente o use el formulario.",
    general: {
      tag: "GENERAL",
      title: "Contacto Corporativo",
      person: "Dirección TBS",
      desc: "Consultas generales, consultoría, alianzas comerciales y relaciones con inversionistas.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "TI & CIBERSEGURIDAD",
      title: "TI & Ciberseguridad",
      person: "Nart Charoukh",
      desc: "Pentesting, DDoS, SOC/SIEM, desarrollo seguro y toda solicitud tecnológica.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "UNIÓN EUROPEA",
      title: "Países de la Unión Europea",
      person: "Dr. Mithat Bayındır",
      desc: "Entrada al mercado UE, licencias, cumplimiento regulatorio y relaciones corporativas europeas.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Llamar",
    actionEmail: "Enviar email",
  },
  ru: {
    eyebrow: "ПРЯМОЙ КОНТАКТ",
    title: "Свяжитесь с профильной командой.",
    lead: "Обратитесь напрямую в нужный отдел или заполните форму ниже.",
    general: {
      tag: "ОБЩИЕ",
      title: "Корпоративные контакты",
      person: "Руководство TBS",
      desc: "Общие запросы, консалтинг, коммерческие партнёрства и инвестиционные отношения.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "IT И КИБЕРБЕЗОПАСНОСТЬ",
      title: "IT и Кибербезопасность",
      person: "Нарт Шарух",
      desc: "Пентесты, DDoS, SOC/SIEM, безопасная разработка и все технологические запросы.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "ЕВРОСОЮЗ",
      title: "Страны ЕС",
      person: "Др. Митхат Байындыр",
      desc: "Выход на рынок ЕС, лицензирование, комплаенс и корпоративные отношения в Европе.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Позвонить",
    actionEmail: "Написать",
  },
  de: {
    eyebrow: "DIREKTER KONTAKT",
    title: "Verbinden Sie sich mit dem passenden Team.",
    lead: "Kontaktieren Sie die zuständige Abteilung direkt oder nutzen Sie das Formular.",
    general: {
      tag: "ALLGEMEIN",
      title: "Unternehmenskontakt",
      person: "TBS Geschäftsleitung",
      desc: "Allgemeine Anfragen, Beratung, Partnerschaften und Investor Relations.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "IT & CYBERSICHERHEIT",
      title: "IT & Cybersicherheit",
      person: "Nart Charoukh",
      desc: "Pentests, DDoS, SOC/SIEM, sichere Softwareentwicklung und alle Technologieanfragen.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "EU-LÄNDER",
      title: "EU-Länder",
      person: "Dr. Mithat Bayındır",
      desc: "EU-Markteintritt, Lizenzierung, regulatorische Compliance und europäische Unternehmensbeziehungen.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Anrufen",
    actionEmail: "E-Mail senden",
  },
  fr: {
    eyebrow: "CONTACT DIRECT",
    title: "Connectez-vous à la bonne équipe.",
    lead: "Contactez directement le département concerné ou utilisez le formulaire.",
    general: {
      tag: "GÉNÉRAL",
      title: "Contact Corporate",
      person: "Direction TBS",
      desc: "Demandes générales, conseil, partenariats commerciaux et relations investisseurs.",
      phone: "+90 533 556 40 50",
      emails: ["info@tbsgroup.com.tr", "ceo@tbsgroup.com.tr"],
    },
    it: {
      tag: "IT & CYBERSÉCURITÉ",
      title: "IT & Cybersécurité",
      person: "Nart Charoukh",
      desc: "Pentest, DDoS, SOC/SIEM, développement logiciel sécurisé et toutes les demandes tech.",
      phone: "+90 501 148 81 07",
      emails: ["nartcyber@tbsgroup.com.tr"],
    },
    eu: {
      tag: "UNION EUROPÉENNE",
      title: "Pays de l'Union européenne",
      person: "Dr. Mithat Bayındır",
      desc: "Entrée sur le marché UE, licensing, conformité réglementaire et relations corporate européennes.",
      phone: "+90 533 556 40 50",
      emails: ["ceo.eu@tbsgroup.com.tr"],
    },
    actionCall: "Appeler",
    actionEmail: "Envoyer un e-mail",
  },
};

// ─────────────────────────────────────────────────────────────
// Technology page · Dedicated contact block (Nart Charoukh)
// ─────────────────────────────────────────────────────────────

export const TECH_CONTACT = {
  tr: {
    eyebrow: "TEKNOLOJİ İLETİŞİM",
    title: "Teknoloji ekibine doğrudan ulaşın.",
    lead: "IT, siber güvenlik, yazılım, QA veya yapay zeka projeleriniz için Nart Charoukh ile doğrudan iletişime geçebilirsiniz.",
    roleTag: "IT & SİBER GÜVENLİK UZMANI",
    personName: "Nart Charoukh",
    phoneLabel: "Telefon",
    emailLabel: "E-posta",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Hemen Ara",
    emailCta: "E-posta Gönder",
    note: "Tüm teknoloji talepleri için gizlilik ve hızlı cevap taahhüdü.",
  },
  en: {
    eyebrow: "TECHNOLOGY CONTACT",
    title: "Reach the tech team directly.",
    lead: "For IT, cybersecurity, software, QA or AI projects you can contact Nart Charoukh directly.",
    roleTag: "IT & CYBER SECURITY EXPERT",
    personName: "Nart Charoukh",
    phoneLabel: "Phone",
    emailLabel: "Email",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Call Now",
    emailCta: "Send Email",
    note: "Confidentiality and rapid response on all technology requests.",
  },
  ar: {
    eyebrow: "تواصل التكنولوجيا",
    title: "تواصل مع فريق التكنولوجيا مباشرة.",
    lead: "لمشاريع IT والأمن السيبراني والبرمجيات والجودة والذكاء الاصطناعي، تواصل مع نارت شاروخ مباشرة.",
    roleTag: "خبير تقنية المعلومات والأمن السيبراني",
    personName: "نارت شاروخ",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "اتصل الآن",
    emailCta: "أرسل بريد",
    note: "سرية تامة ورد سريع لجميع طلبات التكنولوجيا.",
  },
  es: {
    eyebrow: "CONTACTO TECNOLOGÍA",
    title: "Contacte directamente con el equipo tech.",
    lead: "Para TI, ciberseguridad, software, QA o IA puede contactar directamente con Nart Charoukh.",
    roleTag: "EXPERTO EN TI Y CIBERSEGURIDAD",
    personName: "Nart Charoukh",
    phoneLabel: "Teléfono",
    emailLabel: "Email",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Llamar ahora",
    emailCta: "Enviar email",
    note: "Confidencialidad y respuesta rápida en todas las solicitudes.",
  },
  ru: {
    eyebrow: "КОНТАКТ ТЕХНОЛОГИЙ",
    title: "Свяжитесь с технической командой напрямую.",
    lead: "По проектам IT, кибербезопасности, ПО, QA и ИИ обращайтесь напрямую к Нарту Шаруху.",
    roleTag: "ЭКСПЕРТ ПО IT И КИБЕРБЕЗОПАСНОСТИ",
    personName: "Нарт Шарух",
    phoneLabel: "Телефон",
    emailLabel: "Email",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Позвонить",
    emailCta: "Написать",
    note: "Конфиденциальность и быстрый отклик по всем технологическим запросам.",
  },
  de: {
    eyebrow: "TECH-KONTAKT",
    title: "Direkt zum Tech-Team.",
    lead: "Für IT-, Cybersecurity-, Software-, QA- oder KI-Projekte können Sie Nart Charoukh direkt kontaktieren.",
    roleTag: "IT & CYBERSECURITY-EXPERTE",
    personName: "Nart Charoukh",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Jetzt anrufen",
    emailCta: "E-Mail senden",
    note: "Vertraulichkeit und schnelle Antwort bei allen Technologieanfragen.",
  },
  fr: {
    eyebrow: "CONTACT TECH",
    title: "Joignez l'équipe tech directement.",
    lead: "Pour vos projets IT, cybersécurité, logiciel, QA ou IA, contactez directement Nart Charoukh.",
    roleTag: "EXPERT IT & CYBERSÉCURITÉ",
    personName: "Nart Charoukh",
    phoneLabel: "Téléphone",
    emailLabel: "E-mail",
    phone: "+90 501 148 81 07",
    email: "nartcyber@tbsgroup.com.tr",
    callCta: "Appeler",
    emailCta: "Envoyer un e-mail",
    note: "Confidentialité et réponse rapide sur toutes les demandes.",
  },
};

// ─────────────────────────────────────────────────────────────
// Human Resources page / Careers
// ─────────────────────────────────────────────────────────────

export const CAREERS = {
  tr: {
    eyebrow: "İNSAN KAYNAKLARI",
    title: "Türkiye'de kariyer fırsatları.",
    lead: "Türkiye'de beyaz yakalı pozisyonlarda çalışmak isteyen profesyoneller için açık başvuru platformu. Başvurunuz TBS İK ekibi tarafından değerlendirilir ve uygun pozisyonlar için sizinle iletişime geçilir.",
    sectionTitle: "Neden TBS?",
    valueProps: [
      { title: "Kurumsal Kültür", body: "Şeffaf yönetim, net kariyer yolları ve gelişim fırsatları." },
      { title: "Uluslararası Projeler", body: "Avrupa, Orta Doğu ve Türkiye'de uçtan uca projeler." },
      { title: "Öğrenme & Gelişim", body: "Sertifikasyon destekleri, mentorluk ve iç eğitimler." },
    ],
    formTitle: "Başvuru Formu",
    formLead: "Bilgilerinizi paylaşın, İK ekibimiz 5 iş günü içinde dönüş yapacaktır.",
    labels: {
      fullName: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon",
      city: "Şehir",
      position: "İlgilendiğiniz Pozisyon",
      department: "Departman",
      experience: "Deneyim Seviyesi",
      currentRole: "Mevcut Unvan / İşveren",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Brüt Maaş Beklentisi (opsiyonel)",
      availability: "İşe Başlama Süresi",
      message: "Kendinizi Kısaca Tanıtın",
      consent: "Başvurumun TBS tarafından değerlendirilmesi için kişisel verilerimin işlenmesine onay veriyorum.",
    },
    placeholders: {
      position: "Örn. Senior Backend Developer, İnşaat Proje Yöneticisi",
      experience: "Örn. 5 yıl",
      availability: "Örn. 15 gün içinde",
      message: "Tecrübeleriniz, başarılarınız ve TBS'te neden yer almak istediğinizi yazın.",
    },
    departments: [
      { value: "engineering", label: "Yazılım Mühendisliği" },
      { value: "cybersecurity", label: "Siber Güvenlik" },
      { value: "construction", label: "İnşaat & Mühendislik" },
      { value: "finance", label: "Finans & Muhasebe" },
      { value: "sales", label: "Satış & İş Geliştirme" },
      { value: "marketing", label: "Pazarlama & İletişim" },
      { value: "hr", label: "İnsan Kaynakları" },
      { value: "operations", label: "Operasyon & Lojistik" },
      { value: "legal", label: "Hukuk & Uyum" },
      { value: "other", label: "Diğer" },
    ],
    submit: "Başvuruyu Gönder",
    submitting: "Gönderiliyor...",
    successTitle: "Başvurunuz alındı",
    successBody: "İK ekibimiz 5 iş günü içinde sizinle iletişime geçecek.",
    errorTitle: "Bir hata oluştu",
    errorBody: "Lütfen tekrar deneyin.",
    required: "Zorunlu",
    confidential: "Bilgileriniz KVKK kapsamında gizli tutulur.",
  },
  en: {
    eyebrow: "CAREERS",
    title: "Career opportunities in Türkiye.",
    lead: "Open application platform for professionals seeking white-collar positions in Türkiye. Your application will be reviewed by the TBS HR team and matched with relevant openings.",
    sectionTitle: "Why TBS?",
    valueProps: [
      { title: "Corporate Culture", body: "Transparent management, clear career paths and growth opportunities." },
      { title: "International Projects", body: "End-to-end engagements across Europe, MENA and Türkiye." },
      { title: "Learning & Development", body: "Certification support, mentoring and internal training programs." },
    ],
    formTitle: "Application Form",
    formLead: "Share your details and our HR team will get back to you within 5 business days.",
    labels: {
      fullName: "Full name",
      email: "Email",
      phone: "Phone",
      city: "City",
      position: "Position of interest",
      department: "Department",
      experience: "Experience level",
      currentRole: "Current title / employer",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Expected gross salary (optional)",
      availability: "Availability to start",
      message: "Brief introduction",
      consent: "I consent to the processing of my personal data for this application.",
    },
    placeholders: {
      position: "e.g. Senior Backend Developer, Construction PM",
      experience: "e.g. 5 years",
      availability: "e.g. within 15 days",
      message: "Tell us about your experience, achievements and why you want to join TBS.",
    },
    departments: [
      { value: "engineering", label: "Software Engineering" },
      { value: "cybersecurity", label: "Cyber Security" },
      { value: "construction", label: "Construction & Engineering" },
      { value: "finance", label: "Finance & Accounting" },
      { value: "sales", label: "Sales & BD" },
      { value: "marketing", label: "Marketing & Communications" },
      { value: "hr", label: "Human Resources" },
      { value: "operations", label: "Operations & Logistics" },
      { value: "legal", label: "Legal & Compliance" },
      { value: "other", label: "Other" },
    ],
    submit: "Send Application",
    submitting: "Sending...",
    successTitle: "Application received",
    successBody: "Our HR team will contact you within 5 business days.",
    errorTitle: "Something went wrong",
    errorBody: "Please try again.",
    required: "Required",
    confidential: "Your information is kept confidential.",
  },
  ar: {
    eyebrow: "الموارد البشرية",
    title: "فرص مهنية في تركيا.",
    lead: "منصة توظيف مفتوحة للمهنيين الباحثين عن وظائف مكتبية في تركيا. يتم مراجعة طلبك من قبل فريق الموارد البشرية في TBS.",
    sectionTitle: "لماذا TBS؟",
    valueProps: [
      { title: "ثقافة مؤسسية", body: "إدارة شفافة ومسارات مهنية واضحة." },
      { title: "مشاريع دولية", body: "مشاريع شاملة في أوروبا والشرق الأوسط وتركيا." },
      { title: "التعلم والتطوير", body: "دعم الشهادات والإرشاد والتدريب الداخلي." },
    ],
    formTitle: "نموذج الطلب",
    formLead: "شارك بياناتك وسيرد عليك فريق الموارد البشرية خلال 5 أيام عمل.",
    labels: {
      fullName: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      city: "المدينة",
      position: "المنصب المستهدف",
      department: "القسم",
      experience: "مستوى الخبرة",
      currentRole: "المنصب الحالي / صاحب العمل",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "الراتب المتوقع (اختياري)",
      availability: "تاريخ البدء",
      message: "تعريف موجز",
      consent: "أوافق على معالجة بياناتي الشخصية لهذا الطلب.",
    },
    placeholders: {
      position: "مثال: مطور Backend، مدير مشروع إنشاءات",
      experience: "مثال: 5 سنوات",
      availability: "مثال: خلال 15 يومًا",
      message: "أخبرنا عن خبرتك وإنجازاتك وسبب رغبتك بالانضمام.",
    },
    departments: [
      { value: "engineering", label: "هندسة البرمجيات" },
      { value: "cybersecurity", label: "الأمن السيبراني" },
      { value: "construction", label: "الإنشاءات والهندسة" },
      { value: "finance", label: "المالية والمحاسبة" },
      { value: "sales", label: "المبيعات وتطوير الأعمال" },
      { value: "marketing", label: "التسويق والاتصالات" },
      { value: "hr", label: "الموارد البشرية" },
      { value: "operations", label: "العمليات واللوجستيات" },
      { value: "legal", label: "القانون والامتثال" },
      { value: "other", label: "أخرى" },
    ],
    submit: "أرسل الطلب",
    submitting: "جاري الإرسال...",
    successTitle: "تم استلام طلبك",
    successBody: "سيتواصل معك فريق الموارد البشرية خلال 5 أيام عمل.",
    errorTitle: "حدث خطأ",
    errorBody: "يرجى المحاولة مرة أخرى.",
    required: "مطلوب",
    confidential: "معلوماتك تبقى سرية.",
  },
  es: {
    eyebrow: "RECURSOS HUMANOS",
    title: "Oportunidades profesionales en Türkiye.",
    lead: "Plataforma abierta para profesionales que buscan puestos de cuello blanco en Türkiye. Su solicitud será revisada por el equipo de RR. HH. de TBS.",
    sectionTitle: "¿Por qué TBS?",
    valueProps: [
      { title: "Cultura corporativa", body: "Gestión transparente y planes de carrera claros." },
      { title: "Proyectos internacionales", body: "Proyectos integrales en Europa, MENA y Türkiye." },
      { title: "Formación", body: "Certificaciones, mentoría y entrenamientos internos." },
    ],
    formTitle: "Formulario de Postulación",
    formLead: "Comparta sus datos y nuestro equipo de RR. HH. le responderá en 5 días hábiles.",
    labels: {
      fullName: "Nombre completo",
      email: "Email",
      phone: "Teléfono",
      city: "Ciudad",
      position: "Puesto de interés",
      department: "Departamento",
      experience: "Nivel de experiencia",
      currentRole: "Puesto actual / empleador",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Expectativa salarial bruta (opcional)",
      availability: "Disponibilidad",
      message: "Breve presentación",
      consent: "Acepto el tratamiento de mis datos personales para esta postulación.",
    },
    placeholders: {
      position: "Ej. Senior Backend Developer",
      experience: "Ej. 5 años",
      availability: "Ej. dentro de 15 días",
      message: "Cuéntenos su experiencia y por qué quiere unirse.",
    },
    departments: [
      { value: "engineering", label: "Ingeniería de software" },
      { value: "cybersecurity", label: "Ciberseguridad" },
      { value: "construction", label: "Construcción e ingeniería" },
      { value: "finance", label: "Finanzas" },
      { value: "sales", label: "Ventas y BD" },
      { value: "marketing", label: "Marketing" },
      { value: "hr", label: "Recursos humanos" },
      { value: "operations", label: "Operaciones" },
      { value: "legal", label: "Legal" },
      { value: "other", label: "Otro" },
    ],
    submit: "Enviar postulación",
    submitting: "Enviando...",
    successTitle: "Postulación recibida",
    successBody: "Nuestro equipo de RR. HH. lo contactará en 5 días hábiles.",
    errorTitle: "Algo salió mal",
    errorBody: "Por favor, inténtelo de nuevo.",
    required: "Requerido",
    confidential: "Su información se mantiene confidencial.",
  },
  ru: {
    eyebrow: "HR",
    title: "Карьерные возможности в Турции.",
    lead: "Открытая платформа для профессионалов, ищущих работу в офисных должностях в Турции. Вашу заявку рассмотрит HR-команда TBS.",
    sectionTitle: "Почему TBS?",
    valueProps: [
      { title: "Корпоративная культура", body: "Прозрачное управление и понятные карьерные треки." },
      { title: "Международные проекты", body: "Сквозные проекты в Европе, MENA и Турции." },
      { title: "Обучение", body: "Сертификации, менторство и внутренние тренинги." },
    ],
    formTitle: "Форма заявки",
    formLead: "Оставьте данные, HR-команда свяжется с вами в течение 5 рабочих дней.",
    labels: {
      fullName: "Имя и фамилия",
      email: "Email",
      phone: "Телефон",
      city: "Город",
      position: "Желаемая позиция",
      department: "Подразделение",
      experience: "Опыт",
      currentRole: "Текущая должность / работодатель",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Ожидаемая зарплата (опц.)",
      availability: "Готовность выйти",
      message: "Краткое представление",
      consent: "Я согласен на обработку персональных данных для рассмотрения заявки.",
    },
    placeholders: {
      position: "Напр. Senior Backend Developer",
      experience: "Напр. 5 лет",
      availability: "Напр. в течение 15 дней",
      message: "Расскажите об опыте, достижениях и мотивации.",
    },
    departments: [
      { value: "engineering", label: "Разработка ПО" },
      { value: "cybersecurity", label: "Кибербезопасность" },
      { value: "construction", label: "Строительство" },
      { value: "finance", label: "Финансы" },
      { value: "sales", label: "Продажи и BD" },
      { value: "marketing", label: "Маркетинг" },
      { value: "hr", label: "HR" },
      { value: "operations", label: "Операции" },
      { value: "legal", label: "Юридический" },
      { value: "other", label: "Другое" },
    ],
    submit: "Отправить заявку",
    submitting: "Отправка...",
    successTitle: "Заявка получена",
    successBody: "HR-команда свяжется с вами в течение 5 рабочих дней.",
    errorTitle: "Произошла ошибка",
    errorBody: "Пожалуйста, попробуйте снова.",
    required: "Обязательно",
    confidential: "Ваши данные остаются конфиденциальными.",
  },
  de: {
    eyebrow: "KARRIERE",
    title: "Karrieremöglichkeiten in der Türkei.",
    lead: "Offene Bewerbungsplattform für Fachkräfte, die Büropositionen in der Türkei suchen. Ihre Bewerbung wird vom HR-Team von TBS geprüft.",
    sectionTitle: "Warum TBS?",
    valueProps: [
      { title: "Unternehmenskultur", body: "Transparente Führung und klare Karrierepfade." },
      { title: "Internationale Projekte", body: "End-to-End-Projekte in Europa, MENA und der Türkei." },
      { title: "Weiterbildung", body: "Zertifizierung, Mentoring und interne Trainings." },
    ],
    formTitle: "Bewerbungsformular",
    formLead: "Senden Sie uns Ihre Daten – das HR-Team meldet sich innerhalb von 5 Werktagen.",
    labels: {
      fullName: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon",
      city: "Stadt",
      position: "Gewünschte Position",
      department: "Abteilung",
      experience: "Erfahrung",
      currentRole: "Aktuelle Position / Arbeitgeber",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Gehaltsvorstellung (optional)",
      availability: "Verfügbarkeit",
      message: "Kurze Vorstellung",
      consent: "Ich stimme der Verarbeitung meiner personenbezogenen Daten für diese Bewerbung zu.",
    },
    placeholders: {
      position: "z. B. Senior Backend Developer",
      experience: "z. B. 5 Jahre",
      availability: "z. B. innerhalb 15 Tagen",
      message: "Erzählen Sie uns über Ihre Erfahrung und Motivation.",
    },
    departments: [
      { value: "engineering", label: "Softwareentwicklung" },
      { value: "cybersecurity", label: "Cybersicherheit" },
      { value: "construction", label: "Bau & Engineering" },
      { value: "finance", label: "Finanzen" },
      { value: "sales", label: "Vertrieb & BD" },
      { value: "marketing", label: "Marketing" },
      { value: "hr", label: "HR" },
      { value: "operations", label: "Operations" },
      { value: "legal", label: "Legal" },
      { value: "other", label: "Sonstiges" },
    ],
    submit: "Bewerbung senden",
    submitting: "Wird gesendet...",
    successTitle: "Bewerbung erhalten",
    successBody: "Das HR-Team meldet sich innerhalb von 5 Werktagen.",
    errorTitle: "Etwas ist schiefgelaufen",
    errorBody: "Bitte versuchen Sie es erneut.",
    required: "Pflichtfeld",
    confidential: "Ihre Daten bleiben vertraulich.",
  },
  fr: {
    eyebrow: "CARRIÈRES",
    title: "Opportunités de carrière en Türkiye.",
    lead: "Plateforme ouverte pour les professionnels recherchant des postes en Türkiye. Votre candidature sera examinée par l'équipe RH de TBS.",
    sectionTitle: "Pourquoi TBS ?",
    valueProps: [
      { title: "Culture corporate", body: "Management transparent et parcours de carrière clairs." },
      { title: "Projets internationaux", body: "Projets de bout en bout en Europe, MENA et Türkiye." },
      { title: "Formation", body: "Certifications, mentorat et formations internes." },
    ],
    formTitle: "Formulaire de candidature",
    formLead: "Partagez vos informations, notre équipe RH vous répondra sous 5 jours ouvrés.",
    labels: {
      fullName: "Nom complet",
      email: "E-mail",
      phone: "Téléphone",
      city: "Ville",
      position: "Poste visé",
      department: "Département",
      experience: "Niveau d'expérience",
      currentRole: "Poste actuel / employeur",
      linkedin: "LinkedIn / Portfolio URL",
      salary: "Prétention salariale brute (optionnel)",
      availability: "Disponibilité",
      message: "Brève présentation",
      consent: "J'accepte le traitement de mes données personnelles pour cette candidature.",
    },
    placeholders: {
      position: "Ex. Senior Backend Developer",
      experience: "Ex. 5 ans",
      availability: "Ex. sous 15 jours",
      message: "Parlez-nous de votre expérience et de votre motivation.",
    },
    departments: [
      { value: "engineering", label: "Ingénierie logicielle" },
      { value: "cybersecurity", label: "Cybersécurité" },
      { value: "construction", label: "Construction & ingénierie" },
      { value: "finance", label: "Finance" },
      { value: "sales", label: "Ventes & BD" },
      { value: "marketing", label: "Marketing" },
      { value: "hr", label: "RH" },
      { value: "operations", label: "Opérations" },
      { value: "legal", label: "Juridique" },
      { value: "other", label: "Autre" },
    ],
    submit: "Envoyer la candidature",
    submitting: "Envoi...",
    successTitle: "Candidature reçue",
    successBody: "L'équipe RH vous contactera sous 5 jours ouvrés.",
    errorTitle: "Une erreur est survenue",
    errorBody: "Veuillez réessayer.",
    required: "Obligatoire",
    confidential: "Vos informations restent confidentielles.",
  },
};

export default { DEPARTMENTS, TECH_CONTACT, CAREERS };
